/**
 * <product-pack-bundle>
 * Troca o produto real no carrinho sem recarregar a PDP (padrão Bothanica).
 */
if (!customElements.get('product-pack-bundle')) {
  customElements.define(
    'product-pack-bundle',
    class ProductPackBundle extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;

        this.sectionEl = this.closest('.shopify-section') || document;
        const priceTargetSelector = this.getAttribute('data-price-target');
        this.priceTarget = priceTargetSelector
          ? document.querySelector(priceTargetSelector)
          : null;
        this.activeVariantId = null;

        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);

        const checked = this.querySelector(
          '.product-pack-option__input:checked:not(:disabled)'
        );
        if (checked) this.onSelect(checked, true);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onClick);
        this._bound = false;
      }

      onClick(event) {
        const label = event.target.closest('label.product-pack-option');
        if (!label || !this.contains(label)) return;

        const input = label.querySelector('.product-pack-option__input');
        if (!input || input.disabled) return;

        window.requestAnimationFrame(() => {
          if (input.checked) this.onSelect(input);
        });
      }

      onChange(event) {
        const input = event.target;
        if (!input.matches('.product-pack-option__input')) return;
        this.onSelect(input);
      }

      onSelect(input, isInitial) {
        if (!input || input.disabled) return;

        const variantId = input.getAttribute('data-pack-variant-id');
        if (!variantId) return;

        if (!isInitial && variantId === this.activeVariantId) return;

        this.activeVariantId = variantId;

        this.querySelectorAll('.product-pack-option').forEach((card) =>
          card.classList.remove('is-selected')
        );
        const card = input.closest('.product-pack-option');
        if (card) card.classList.add('is-selected');

        this.updateFormVariant(variantId);

        if (card) {
          this.syncPrice(card);
          if (!isInitial) this.updateMainImage(input);
        }
      }

      updateFormVariant(variantId) {
        const idInputs = this.sectionEl.querySelectorAll(
          'product-form [name="id"], .product-variant-id'
        );
        idInputs.forEach((el) => {
          el.value = variantId;
          el.removeAttribute('disabled');
        });

        const productForm = this.sectionEl.querySelector('product-form');
        if (productForm && typeof productForm.toggleSubmitButton === 'function') {
          productForm.toggleSubmitButton(false);
        }
      }

      syncPrice(card) {
        if (!this.priceTarget) return;
        const tpl = card.querySelector('template[data-pack-price-sync]');
        if (!tpl) return;
        this.priceTarget.innerHTML = tpl.innerHTML;
      }

      updateMainImage(input) {
        const imageSrc = input.getAttribute('data-pack-image-src');
        if (!imageSrc) return;

        const sectionId = this.getAttribute('data-section-id');
        const gallery = document.getElementById('MediaGallery-' + sectionId);
        if (!gallery) return;

        const activeSlide =
          gallery.querySelector('.product__media-item.is-active') ||
          gallery.querySelector('.product__media-item');
        if (!activeSlide) return;

        const img = activeSlide.querySelector('img');
        if (!img) return;

        const imageSrcset = input.getAttribute('data-pack-image-srcset');
        const imageAlt = input.getAttribute('data-pack-image-alt');

        img.setAttribute('src', imageSrc);
        if (imageSrcset) img.setAttribute('srcset', imageSrcset);
        if (imageAlt) img.setAttribute('alt', imageAlt);
      }
    }
  );
}
